<template>
  <v-card flat class="price-list-detail-table" color="grey lighten-3">
    <v-row>
      <v-col class="left-block" cols="12" lg="7" md="12">
        <div class="price-list-detail-table-info price-list-name">
          {{ $t("priceList.priceListDetail.header.priceListName") }}
          <strong>{{
            isPriceListProposal ? priceList.priceList.name : priceList.name
          }}</strong>
        </div>
        <div
          v-if="priceList.publicationState && isPriceListProposal"
          class="price-list-detail-table-info price-list-status"
          :class="priceList.publicationState"
        >
          {{ $t("priceList.priceListDetail.header.status") }}
          <PriceListProposalStatus
            :publicationState="priceList.publicationState"
          />
        </div>
        <div v-else>
          {{ $t("priceList.priceListDetail.header.status") }}

          <PriceListProposalStatus
            :status="
              $dayjs().isBefore($dayjs(priceList.toDate).add(1, 'day')) ? 1 : 0
            "
          />
        </div>
        <div v-if="!isPriceListProposal">
          {{ $t("priceList.priceListDetail.header.id") }}

          {{ priceList.priceListId }}
        </div>
        <div v-if="!isPriceListProposal">
          <!-- BEGIN DATE INIT -->
          <v-menu
            ref="menu"
            v-model="menuAtDate"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="atDatePickerModel"
                :label="$t('priceList.insertPriceListProposal.validityDate')"
                class="mt-1"
                required
                outlined
                dense
                v-bind="attrs"
                v-on="on"
                append-icon="$calendar"
                @click:append="menuAtDate = true"
                readonly
              >
              </v-text-field>
            </template>
            <v-date-picker
              class="w-100"
              locale="it-IT"
              ref="picker"
              color="primary"
              v-model="selectedAtDateFromDate"
              :show-current="$dayjs().format('YYYY-MM-DD')"
              first-day-of-week="1"
              type="date"
              no-title
              @input="handleDateChangeFromDate"
            ></v-date-picker>
          </v-menu>
          <!-- BEGIN DATE END -->
        </div>
        <v-card-actions class="px-0 d-flex flex-wrap">
          <v-btn
            v-if="!isPriceListProposal"
            color="primary"
            outlined
            class="mt-1"
            depressed
            @click="editPriceList()"
          >
            {{ $t("priceList.priceListDetail.edit") }}
            <v-icon small class="pl-1">$edit</v-icon>
          </v-btn>
          <v-btn
            v-if="
              !isPriceListProposal &&
                $dayjs().isBefore($dayjs(priceList.toDate))
            "
            color="primary"
            outlined
            class="mt-1"
            depressed
            @click="closePriceList()"
          >
            {{ $t("priceList.priceListDetail.close") }}
            <v-icon small class="pl-1">mdi-lock-outline</v-icon>
          </v-btn>
          <v-btn
            v-if="
              isPriceListProposal &&
                priceList.publicationState.publicationStateId == -1
            "
            color="primary"
            outlined
            class="mt-1"
            depressed
            @click="deletePriceListProposal()"
          >
            {{ $t("priceList.priceListDetail.delete") }}
            <v-icon small class="pl-1">$delete</v-icon>
          </v-btn>
          <v-btn
            v-if="
              isPriceListProposal &&
                priceList.publicationState.publicationStateId == -1
            "
            color="primary"
            depressed
            @click="validateProposalRequest()"
          >
            {{ $t("priceList.priceListDetail.approvalRequest") }}
            <v-icon small class="pl-1">$starfull</v-icon>
          </v-btn>
          <v-btn
            v-if="
              isPriceListProposal &&
                priceList.publicationState.publicationStateId == -1
            "
            color="primary"
            depressed
            @click="editPriceListProposal()"
          >
            {{ $t("priceList.priceListDetail.editDate") }}
            <v-icon small class="pl-1">$edit</v-icon>
          </v-btn>
          <v-btn
            v-if="
              priceList.active == 1 &&
                !isPriceListProposal &&
                hasRole('admin', 'company_manager')
            "
            color="primary"
            outlined
            class="mt-1"
            depressed
            @click="deletePriceList()"
          >
            {{ $t("priceList.priceListDetail.delete") }}
            <v-icon small class="pl-1">$delete</v-icon>
          </v-btn>
          <v-btn
            v-if="
              priceList.active == 1 &&
                !isPriceListProposal &&
                hasRole('admin', 'company_manager')
            "
            color="primary"
            outlined
            class="mt-1"
            depressed
            @click="deleteAndCopyPriceList()"
          >
            {{ $t("priceList.priceListDetail.deleteAndCopy") }}
            <v-icon small class="pl-1">$delete</v-icon>
            <v-icon small class="pl-1">mdi-content-copy</v-icon>
          </v-btn>
          <v-btn
            v-if="
              priceList.active == 1 &&
                !isPriceListProposal &&
                hasRole('admin', 'company_manager')
            "
            color="primary"
            outlined
            class="mt-1"
            depressed
            @click="openCopyPriceListProposal()"
          >
            COPIA
            <v-icon small class="pl-1">mdi-content-copy</v-icon>
          </v-btn>
        </v-card-actions>
      </v-col>
      <v-col class="right-block" cols="12" lg="5" md="12">
        <div class="price-list-detail-table-info price-list-begin-date">
          {{ $t("priceList.priceListDetail.header.beginDate") }}
          <strong>
            {{
              $dayjs(
                priceList.priceList && priceList.priceList.fromDate
                  ? priceList.priceList.fromDate
                  : priceList.fromDate
              ).format("DD MMMM YYYY")
            }}
          </strong>
        </div>
        <div class="price-list-detail-table-info price-list-end-date">
          {{ $t("priceList.priceListDetail.header.endDate") }}
          <strong>
            {{
              $dayjs(
                priceList.priceList && priceList.priceList.toDate
                  ? priceList.priceList.toDate
                  : priceList.toDate
              ).format("DD MMMM YYYY")
            }}
          </strong>
        </div>
        <div class="price-list-detail-table-info price-list-end-date">
          {{ $t("priceList.priceListDetail.header.warehouse") }}
          <strong>
            {{
              priceList
                ? (priceList.priceListProposal &&
                    priceList.priceListProposal.warehouse &&
                    priceList.priceListProposal.warehouse.name) ||
                  (priceList.warehouse && priceList.warehouse.name) ||
                  ""
                : ""
            }}
          </strong>
        </div>
        <div class="price-list-detail-table-info price-list-end-date">
          {{ $t("priceList.priceListDetail.header.items") }}
          <strong>
            {{ totItems }}
          </strong>
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>
<style lang="scss">
.price-list-detail-table {
  padding: 16px;
  @media #{map-get($display-breakpoints, "lg-and-up")} {
    .left-block {
      border-right: 1px solid rgba(0, 0, 0, 0.2);
    }
  }
  .price-list-detail-table-info {
    font-size: 1rem;
    line-height: 2rem;
  }
  .price-list-name {
    strong {
      color: var(--v-primary-base);
    }
  }
}
</style>
<script>
import PriceListProposalStatus from "@/components/priceList/PriceListProposalStatus.vue";
import ModifyPriceListProposal from "@/components/priceList/ModifyPriceListProposal.vue";
import InsertPriceListProposal from "@/components/priceList/InsertPriceListProposal.vue";
import ClosePriceList from "@/components/priceList/ClosePriceList.vue";
import priceListProposalService from "~/service/priceListProposalService";
import priceListService from "~/service/priceListService";

import login from "~/mixins/login";
import cartInfo from "~/mixins/cartInfo";
import CopyPriceList from "./CopyPriceList.vue";
import { mapGetters } from "vuex";

export default {
  name: "PriceListDetailHeader",
  mixins: [cartInfo, login],
  components: {
    PriceListProposalStatus
  },
  props: {
    priceList: { type: Object, required: true },
    isPriceListProposal: { type: Boolean, default: false },
    totItems: { type: Number, default: 0 }
  },
  data() {
    return {
      menuAtDate: false,
      selectedAtDateFromDate: null
    };
  },
  computed: {
    ...mapGetters({
      hasRole: "cart/hasRole",
      getUser: "cart/getUser"
    }),
    atDatePickerModel: {
      get: function() {
        return this.selectedAtDateFromDate
          ? this.$dayjs(this.selectedAtDateFromDate).format("DD-MM-YYYY")
          : "";
      },
      set: function(value) {
        this.selectedAtDateFromDate = this.$dayjs(value, "DD-MM-YYYY").format(
          "DD-MM-YYYY"
        );
      }
    }
  },
  methods: {
    async editPriceList(copyPriceList = false) {
      if (this.checkUserHasClusterPriceListProposal()) {
        const confirm = await this.$dialog.confirm({
          text: this.$t(
            "priceList.priceListList.confirmPriceListProposalSegment",
            {
              segmentName: this.segmentName
            }
          )
        });
        if (!confirm) return;
      }
      let newProposal = null;
      if (copyPriceList) {
        newProposal = await this.$dialog.show(InsertPriceListProposal, {
          waitForResult: true,
          replacedPriceListId: this.priceList.priceListId,
          replacedPriceListName: this.priceList.name,
          priceList: this.priceList,
          previousPriceListId: this.priceList.priceListId
        });
      } else {
        newProposal = await this.$dialog.show(InsertPriceListProposal, {
          waitForResult: true,
          replacedPriceListId: this.priceList.priceListId,
          replacedPriceListName: this.priceList.name,
          priceList: this.priceList
        });
      }

      if (newProposal && newProposal === "changeWharehouse") {
        await this.openAddressSelector();
        setTimeout(() => {
          this.editPriceList();
        }, 300);
      } else if (newProposal && newProposal.priceListProposalId) {
        this.$router.push({
          name: "PriceListProposalDetail",
          params: {
            priceListProposalId: newProposal.priceListProposalId
          }
        });
      }
    },
    async copyPriceList() {
      const newProposal = await this.$dialog.show(CopyPriceList, {
        waitForResult: true,
        replacedPriceListId: this.priceList.priceListId,
        replacedPriceListName: this.priceList.name,
        priceList: this.priceList
      });

      if (newProposal && newProposal === "changeWharehouse") {
        await this.openAddressSelector();
        setTimeout(() => {
          this.copyPriceList();
        }, 300);
      } else if (newProposal && newProposal.priceListProposalId) {
        this.$router.push({
          name: "PriceListProposalDetail",
          params: {
            priceListProposalId: newProposal.priceListProposalId
          }
        });
      }
    },
    async closePriceList() {
      const newProposal = await this.$dialog.show(ClosePriceList, {
        waitForResult: true,
        priceList: this.priceList
      });
      /*if (newProposal && newProposal === "changeWharehouse") {
        await this.openAddressSelector();
        setTimeout(() => {
          this.editPriceList();
        }, 300);
      } else */ if (
        newProposal &&
        newProposal.priceListId
      ) {
        this.$router.push({
          name: "PriceListDetail",
          params: {
            priceListId: newProposal.priceListId
          }
        });
      }
    },
    async editPriceListProposal() {
      const modifyProposal = await this.$dialog.show(ModifyPriceListProposal, {
        waitForResult: true,
        priceListProposal: this.priceList
      });
      if (modifyProposal && modifyProposal.priceListProposalId) {
        this.$emit("updatePriceList", modifyProposal);
      }
    },
    async deletePriceList(refresh = true) {
      try {
        const confirmResult = await this.$dialog.confirm({
          text: global.vm.$t("priceList.priceListDetail.deleteConfirm", {
            priceListName: this.priceList.name
          })
        });
        if (confirmResult) {
          let deleteResult = await priceListService.deletePriceList(
            this.priceList
          );
          if (
            deleteResult.response &&
            deleteResult.response.status == 0 &&
            refresh
          ) {
            this.$router.push({ name: "PriceListProposalList" });
          }
          return deleteResult;
        }
      } catch (err) {
        console.log(err);
      }
    },
    checkUserHasClusterPriceListProposal() {
      if (!this.getUser || !this.getUser.crmUserSegments) {
        return false;
      }

      const userSegment = this.getUser.crmUserSegments.find(
        userSegment => userSegment.crmSegment?.crm_cluster?.cod === "CLUSTER_CP"
      );

      if (userSegment) {
        // Set the crmSegmentId to the crm_cluster_id
        this.crmSegmentId = userSegment.crmSegment.crmSegmentId;
        this.segmentName = userSegment.crmSegment.code;
        return true;
      }

      return false;
    },
    async openCopyPriceListProposal() {
      let newProposal = await this.$dialog.show(InsertPriceListProposal, {
        waitForResult: true,
        copyMode: true,
        previousPriceListId: this.priceList.priceListId
      });
      if (newProposal && newProposal === "changeWharehouse") {
        await this.openAddressSelector();
        setTimeout(() => {
          this.openCopyPriceListProposal();
        }, 300);
      }
    },
    async deletePriceListProposal() {
      try {
        const confirmResult = await this.$dialog.confirm({
          text: global.vm.$t("priceList.priceListDetail.deleteConfirm", {
            priceListName: this.priceList.name
          })
        });
        if (confirmResult) {
          let deleteResult = await priceListProposalService.delete(
            this.priceList.priceListProposalId
          );
          if (deleteResult.response && deleteResult.response.status == 0) {
            this.$router.push({ name: "PriceListList" });
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    async validateProposalRequest() {
      const agreedConfirm = await this.$dialog.confirm({
        text: global.vm.$t("priceList.priceListItem.validationConfirmDialog")
      });
      if (agreedConfirm) {
        this.$emit("validateProposalRequest");
      }
    },
    async deleteAndCopyPriceList() {
      const deleteResult = await this.deletePriceList(false);
      if (
        deleteResult &&
        deleteResult.response &&
        deleteResult.response.status == 0
      ) {
        await this.editPriceList(true);
      }
    },
    handleDateChangeFromDate(date) {
      this.selectedAtDateFromDate = date;
      this.menuAtDate = false;
      this.callServiceWithAtDate();
    },
    async callServiceWithAtDate() {
      if (!this.selectedAtDateFromDate) return;

      this.$emit("dateChanged", this.selectedAtDateFromDate);
    }
  },
  mounted() {
    if (
      this.$dayjs().isBefore(this.$dayjs(this.priceList.toDate).add(1, "day"))
    )
      this.selectedAtDateFromDate = new Date().toISOString().substr(0, 10);
  }
};
</script>
